import { FileWithPreview } from 'react-dropzone';

import { CanvasPageType } from '../../components/ImageCanvasIFrame/ImageCanvasIFrame';
import { BannerId } from '../../typings/banners';
import { ValidationResultItem } from '../../typings/common';
import { AdvType } from '../../typings/domain';

export const SHOW_BANNER_IMAGE_CANVAS = 'SHOW_BANNER_IMAGE_CANVAS';
export type SHOW_BANNER_IMAGE_CANVAS = typeof SHOW_BANNER_IMAGE_CANVAS;
export interface ShowBannerImageCanvas {
    type: SHOW_BANNER_IMAGE_CANVAS;
    bannerId: BannerId;
    canvasType?: CanvasPageType;
}
export function showBannerImageCanvas(
    bannerId: BannerId,
    canvasType?: CanvasPageType
): ShowBannerImageCanvas {
    return {
        type: SHOW_BANNER_IMAGE_CANVAS,
        bannerId,
        canvasType
    };
}

export const CLOSE_BANNER_IMAGE_CANVAS = 'CLOSE_BANNER_IMAGE_CANVAS';
export type CLOSE_BANNER_IMAGE_CANVAS = typeof CLOSE_BANNER_IMAGE_CANVAS;

export interface CloseBannerImageCanvas {
    type: CLOSE_BANNER_IMAGE_CANVAS;
    bannerId: BannerId;
}

export function closeBannerImageCanvas(
    bannerId: BannerId
): CloseBannerImageCanvas {
    return {
        type: CLOSE_BANNER_IMAGE_CANVAS,
        bannerId
    };
}

export const UPLOAD_AD_BANNER_IMAGES = 'UPLOAD_AD_BANNER_IMAGES';
export type UPLOAD_AD_BANNER_IMAGES = typeof UPLOAD_AD_BANNER_IMAGES;
export interface UploadAdBannerImages {
    type: UPLOAD_AD_BANNER_IMAGES;
    bannerId: BannerId;
    filesToUpload: FileWithPreview[];
    filesInvalid: Record<string, ValidationResultItem[]>;
    bannerType: AdvType;
    isLocalUploading?: boolean;
}

export function uploadAdBannerImages(
    bannerId: BannerId,
    filesToUpload: FileWithPreview[],
    filesInvalid: Record<string, ValidationResultItem[]>,
    bannerType: AdvType,
    isLocalUploading?: boolean
): UploadAdBannerImages {
    return {
        type: UPLOAD_AD_BANNER_IMAGES,
        bannerId,
        filesToUpload,
        filesInvalid,
        bannerType,
        isLocalUploading
    };
}

export const VALIDATE_AD_BANNER_IMAGES = 'VALIDATE_AD_BANNER_IMAGES';
export type VALIDATE_AD_BANNER_IMAGES = typeof VALIDATE_AD_BANNER_IMAGES;
export interface ValidateAdBannerImages {
    type: VALIDATE_AD_BANNER_IMAGES;
    bannerId: BannerId;
    files: FileWithPreview[];
    bannerType: AdvType;
    isLocalUploading?: boolean;
}

export function validateAdBannerImages(
    bannerId: BannerId,
    files: FileWithPreview[],
    bannerType: AdvType,
    isLocalUploading?: boolean
): ValidateAdBannerImages {
    return {
        type: VALIDATE_AD_BANNER_IMAGES,
        bannerId,
        files,
        bannerType,
        isLocalUploading
    };
}

export const CHANGE_BANNER_IMAGE_CREATIVE_UPLOADING_LINK =
    'CHANGE_BANNER_IMAGE_CREATIVE_UPLOADING_LINK';
export type CHANGE_BANNER_IMAGE_CREATIVE_UPLOADING_LINK = typeof CHANGE_BANNER_IMAGE_CREATIVE_UPLOADING_LINK;
export interface ChangeBannerImageCreativeUploadingLink {
    type: CHANGE_BANNER_IMAGE_CREATIVE_UPLOADING_LINK;
    link: string;
    bannerId: BannerId;
}

export function changeBannerImageCreativeUploadingLink(
    link: string,
    bannerId: BannerId
): ChangeBannerImageCreativeUploadingLink {
    return {
        type: CHANGE_BANNER_IMAGE_CREATIVE_UPLOADING_LINK,
        link,
        bannerId
    };
}

export const UPLOAD_BANNER_IMAGE_CREATIVE_BY_LINK =
    'UPLOAD_BANNER_IMAGE_CREATIVE_BY_LINK';
export type UPLOAD_BANNER_IMAGE_CREATIVE_BY_LINK = typeof UPLOAD_BANNER_IMAGE_CREATIVE_BY_LINK;
export interface UploadBannerImageCreativeByLink {
    type: UPLOAD_BANNER_IMAGE_CREATIVE_BY_LINK;
    bannerId: string;
}

export function uploadBannerImageCreativeByLink(
    bannerId: string
): UploadBannerImageCreativeByLink {
    return {
        type: UPLOAD_BANNER_IMAGE_CREATIVE_BY_LINK,
        bannerId
    };
}

export type BannerImageActions =
    | ShowBannerImageCanvas
    | UploadAdBannerImages
    | UploadBannerImageCreativeByLink
    | ValidateAdBannerImages
    | ChangeBannerImageCreativeUploadingLink
    | CloseBannerImageCanvas;
